module.exports = __webpack_public_path__ + "img/DSC_0068.2f650cbd.jpg";